(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (root.dataset.ffHeroInit) return;
      root.dataset.ffHeroInit = '1';
      var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      var zone = root.querySelector('.ff-hero__slides');
      if (!zone) return;
      var slides = [].slice.call(root.querySelectorAll('.ff-hero__slide'));
      var dots = [].slice.call(root.querySelectorAll('.ff-hero__dot'));
      if (slides.length < 2) return;
      var i = 0, timer = null;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      }
      function play() { if (reduced) return; stop(); timer = setInterval(function () { go(i + 1); }, 6000); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.dataset.i); play(); }); });
      zone.addEventListener('mouseenter', stop);
      zone.addEventListener('mouseleave', play);
      play();
    }
    function initAll() {
      [].slice.call(document.querySelectorAll('.ff-hero')).forEach(initHero);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-product"] && !Shopify.designMode) return;
  try {
    
  /* ===== STAGE: mano coloca el jar (entrada, UNA vez) -> idle de respiracion (loop) ===== */
  (function(){
    function init(){
      var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      [].forEach.call(document.querySelectorAll('.ff-product__stagebox'), function(box){
        var ve = box.querySelector('.ff-product__vid-entrance');
        var vi = box.querySelector('.ff-product__vid-idle');
        if(!ve || !vi) return;
        var canPlay=false;
        ve.addEventListener('loadeddata',function(){ canPlay=true; });
        if(reduced || !ve.canPlayType || !ve.canPlayType('video/mp4')) return; /* poster still queda */
        function startIdle(){
          vi.classList.add('on');
          vi.play().catch(function(){});
          ve.classList.remove('on');
        }
        ve.addEventListener('ended',startIdle);
        var seen=false;
        var sio=new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if(e.isIntersecting && !seen){
              seen=true; sio.unobserve(box);
              if(canPlay || ve.readyState>=2){ ve.classList.add('on'); ve.play().catch(startIdle); }
              else{
                ve.addEventListener('loadeddata',function(){ ve.classList.add('on'); ve.play().catch(startIdle); },{once:true});
                ve.addEventListener('error',startIdle,{once:true});
              }
            }
          });
        },{threshold:.45});
        sio.observe(box);
      });
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
    else { init(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-story"] && !Shopify.designMode) return;
  try {
    
  /* ===== marquee curvo (port vanilla de CurvedLoop, React Bits) ===== */
  (function(){
    var PHRASE_DEFAULT='Run ✦ Lift ✦ Recover ✦ Repeat ✦ Stop settling ✦ ';
    var SEPCHAR='✦';
    var SLOT=' ';           /* em space: reserva el hueco donde se dibuja el isotipo */
    var FS=64;                    /* debe coincidir con el font-size del CSS */
    var ISO_W=389.3, ISO_H=406.9; /* viewBox del isotipo */
    var reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    var loops=document.querySelectorAll('.ff-story__curveloop');

    Array.prototype.forEach.call(loops,function(loop){
      var tp=loop.querySelector('.ff-story__looppath'), tx=loop.querySelector('.ff-story__looptext');
      var marksG=loop.querySelector('.ff-story__marks');
      var isoDef=loop.querySelector('.ff-story__isodef');
      if(!tp||!tx) return;

      var raw=loop.getAttribute('data-phrase');
      var PHRASE=(raw && raw.trim())?raw:PHRASE_DEFAULT;

      var curve=loop.querySelector('defs path');
      /* si falta algo, se deja el caracter estrella tal cual */
      var canPlace = !!(marksG && isoDef && curve && curve.getPointAtLength && tx.getSubStringLength);
      var PHRASE_RENDER = canPlace ? PHRASE.split(SEPCHAR).join(SLOT) : PHRASE;

      tp.textContent=PHRASE_RENDER;
      requestAnimationFrame(function(){
        var unit=tx.getComputedTextLength();
        if(!unit){ tp.textContent=PHRASE_RENDER.repeat(6); return; }
        var copies=Math.ceil(2200/unit)+2;
        var full=PHRASE_RENDER.repeat(copies);
        tp.textContent=full;

        var marks=[], base=[], scale=(FS*0.55)/ISO_H, pathLen=0;
        if(canPlace){
          pathLen=curve.getTotalLength();
          var isoId=isoDef.getAttribute('id');
          /* CLAVE DE RENDIMIENTO: la distancia de cada separador se mide UNA sola vez.
             Consultarla por frame forzaba re-layout del texto y tiraba el fps al piso. */
          for(var i=0;i<full.length;i++){
            if(full[i]!==SLOT) continue;
            var d;
            try{ d=tx.getSubStringLength(0,i); }catch(e){ continue; }
            base.push(d + FS*0.5);   /* centro del hueco */
            var u=document.createElementNS('http://www.w3.org/2000/svg','use');
            u.setAttribute('href','#'+isoId);
            u.setAttribute('visibility','hidden');
            marksG.appendChild(u);
            marks.push(u);
          }
        }
        /* centrado optico: el isotipo queda a la altura del centro de las mayusculas (~.36em) */
        var dx=-ISO_W*scale/2, dy=-FS*0.36-(ISO_H*scale)/2;

        /* posicion y angulo se sacan del PATH (geometria barata), no del texto */
        function place(off){
          for(var k=0;k<marks.length;k++){
            var d=off+base[k];
            if(d<0||d>pathLen){ marks[k].setAttribute('visibility','hidden'); continue; }
            var p=curve.getPointAtLength(d);
            var q=curve.getPointAtLength(Math.min(d+1,pathLen));
            var ang=Math.atan2(q.y-p.y,q.x-p.x)*180/Math.PI;
            marks[k].setAttribute('visibility','visible');
            marks[k].setAttribute('transform',
              'translate('+p.x+','+p.y+') rotate('+ang+') translate('+dx+','+dy+') scale('+scale+')');
          }
        }

        var off=-unit, SPEED=.6;
        place(off);
        if(reduced) return;
        (function step(){
          off-=SPEED;
          if(off<=-2*unit) off+=unit;
          tp.setAttribute('startOffset', off+'px');
          place(off);
          requestAnimationFrame(step);
        })();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-waitlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = document.getElementById('ff-wlm');
    if (!modal) return;
    var form = document.querySelector('#waitlist form');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(function () { modal.classList.add('on'); });
      var cta = modal.querySelector('.ff-wlm__cta');
      if (cta) setTimeout(function () { try { cta.focus({ preventScroll: true }); } catch (e) {} }, 900);
    }
    function closeModal() {
      modal.classList.remove('on');
      document.body.style.overflow = '';
      setTimeout(function () { modal.hidden = true; }, 500);
      if (window.history && history.replaceState && /customer_posted/.test(location.search)) {
        history.replaceState({}, '', location.pathname + location.hash);
      }
      try { (lastFocus || document.body).focus({ preventScroll: true }); } catch (e) {}
    }

    modal.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-ffclose]')) { ev.preventDefault(); closeModal(); }
    });
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && modal.classList.contains('on')) closeModal();
    });

    // el servidor ya proceso el envio (camino sin JS o recarga): abrir de una
    if (modal.getAttribute('data-ff-autoopen') === 'true') openModal();

    if (!form || !window.fetch || !window.FormData) return;

    var btn = form.querySelector('[data-ff-submit]');
    var label = form.querySelector('[data-ff-btnlabel]');
    var jsErr = form.querySelector('.ff-wait__err--js');
    var original = label ? label.textContent : '';

    function busy(on) {
      if (btn) btn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (label) label.textContent = on ? 'Adding you...' : original;
    }
    function showError(msg) {
      if (!jsErr) return;
      jsErr.textContent = msg;
      jsErr.hidden = false;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (jsErr) jsErr.hidden = true;
      busy(true);

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      })
        .then(function (res) {
          return res.text().then(function (html) { return { url: res.url || '', html: html }; });
        })
        .then(function (r) {
          if (/customer_posted=true/.test(r.url)) {
            busy(false);
            form.reset();
            var micro = document.querySelector('.ff-wait__micro');
            if (micro) micro.hidden = true;
            openModal();
            return;
          }
          // error de validacion devuelto por Shopify
          var doc = new DOMParser().parseFromString(r.html, 'text/html');
          var err = doc.querySelector('#waitlist .ff-wait__err');
          if (err && err.textContent.trim()) {
            busy(false);
            showError(err.textContent.trim());
            return;
          }
          // no se pudo interpretar (challenge anti-bot u otra cosa): al camino nativo
          form.submit();
        })
        .catch(function () { form.submit(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
